<template>
<h4 v-if="isNoConnectionToServer">Немає св'язку з сервером</h4>

<SubscriptionsTable
	:isTableLoading="isTableLoading"
	:headers="tableHeader"
	:items="tableItems"
	:onSubmit="onSubmit"
	:notifacation-text="$options.notifacationText"
/>

<pop-up-modal
	v-model:show="isSubmitResultModal"
	title="Оновлення підписок"
	:title-style="submitResultBgStyle"
	confirmButtonTitle="Ок"
	rejectButtonTitle=""
	size="modal-md"
>
	<template v-slot:body>
		{{ submitResultText }}
	</template>
</pop-up-modal>
</template>


<script>
import SubscriptionsTable from './SubscriptionsTable.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { usePostsStore } from '@/stores/PostsStore.js'
import PopUpModal from '../PopUpModal.vue'
import { Post } from '@/models/post.js'

export default {
	notifacationText: new Map([
		[Post.passportKeys.notificationDistributionLists.connection, 'Сповіщати про втрату зв\'язку'],
		[Post.passportKeys.notificationDistributionLists.potentialOutOfRange, 'Потенціал поза цільовим діапазоном'],
	]),
	
	components: {
		PopUpModal,
		SubscriptionsTable,
	},

	props: {},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()

		return {
			accountStore,
			postsStore,
			Post,
		}
	},

	data() {
		return {
			//
			isNoConnectionToServer: false,
			// Table
			isTableLoading: true,
			// Submit result modal
			isSubmitResultModal: false,
			submitResultText: '',
			submitResultBgStyle: '', // bg-success-subtle or bg-danger-subtle
		}
	},

	created() {
		this.initPage()
	},

	mounted() {
		document.title = "Підписки КВП"
	},

	methods: {
		async initPage() {
			// Read all posts
			await this.postsStore.readPosts((result) => {
				this.isNoConnectionToServer = !result
				this.isTableLoading = !result
			})
		},

		onSubmit(values) {
			//console.log('form values', values)
			const postId = values.postId
			const post = this.postsStore.post(postId)
			
			// Iterate notification
			Post.notificationNames.forEach((key) => {
				// If notification is active in form
				if(values[key]) {
					post?.subscribeToNotification(this.userId, key)
				} else {
					post?.unsubscribeFromNotification(this.userId, key)
				}
			})

			// Add notification_distribution_lists to form values
			const payload = {}
			payload[Post.passportKeys.notificationDistributionLists.self] =
				post.passport.get(Post.passportKeys.notificationDistributionLists.self)
			//console.log('pyload', payload)

			this.postsStore.updatePasport((result) => {
				let resultText = ''
				
				if (result) {
					resultText = `Підписки на сповіщення КВП "${post.name}" успішно оновлено.`
				} else {
					console.error("Passport (notificationDistributionLists) update error")
					resultText = `Під час оновлення підписок на сповіщення КВП "${post.name}" сталася помилка.`
				}

				this.setSubmitResult(resultText, result)
			}, postId, payload)
		},

		setSubmitResult(text, sucess=true) {
			this.submitResultText = text
			this.submitResultBgStyle = sucess ? 'bg-success-subtle' : 'bg-danger-subtle'
			this.isSubmitResultModal = true
		}
	},

	computed: {
		userId() { return this.accountStore.userId },

		tableHeader() {
			const header = []
			
			header.push({ text: 'Назва', value: 'name', sortable: true })
			if (this.accountStore.isPrimary) {
				header.push({ text: 'Організація', value: Post.passportKeys.orgName, sortable: true })
			}
			header.push({ text: 'Кількість підписок', value: 'subscriptions_count' })

			return header
		},

		tableItems() {
			const tableItems = []

			// Iterate over posts, make post row
			this.postsStore?.postsArray.forEach(post => {
				if (!post.isActive) {
					return
				}
				//console.log("Post", post.name, post)
				let row = new Object()
				// Notification keys
				const keys = Post.passportKeys.notificationDistributionLists

				row['id'] = post.id
				row['name'] = post.shortName ? post.shortName : post.name
				row[Post.passportKeys.orgName] = post.passport.get(Post.passportKeys.orgName)
				row['subscriptions_count'] = 0
				row['layout'] = {
					columns: [
						[keys.connection, keys.potentialOutOfRange],
					],
					resultText: '',
				}
				row['form'] = { postId: post.id }
				
				const subcriptions = post.passport.get(Post.passportKeys.notificationDistributionLists.self)
				// Iterate all alert keys
				row['layout'].columns.flat(1).forEach((alertKey) => {
					if (alertKey === Post.passportKeys.notificationDistributionLists.self) {
						return
					}

					// Search subscription for this user account
					const isSubscribe = subcriptions
						? subcriptions[alertKey]?.includes(this.userId)
						: false
					row['form'][alertKey] = isSubscribe

					row['subscriptions_count'] = isSubscribe ? row['subscriptions_count'] + 1 : row['subscriptions_count']
				})

				tableItems.push(row)
			})

			return tableItems
		},
	},

	beforeUnmount() {},

	unmounted() {},
}
</script>




<style scoped>
</style>
